<!-- 采集器列表 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="table-wrap" shadow="never">
        <el-row>
          <div class="filter-container">
            <el-form label-width="100px">
              <el-row :gutter="15">
                <el-col :span="4">
                  <el-button
                    type="warning"
                    icon="el-icon-coin"
                    @click="recharge"
                  >续费</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="data-container">
            <el-table
              ref="multipleTable"
              v-loading="loading"
              :data="tableData"
              :style="{ width: '100%',marginTop:'20px'}"
            >
              <el-table-column
                type="selection"
                align="center"
                :selectable="selectable"
              />
              <el-table-column
                label="电站名称"
                prop="orgname"
                align="center"
              />
              <el-table-column
                label="采集器编号"
                align="center"
                prop="gatewaysn"
              />
              <el-table-column
                label="产品类型"
                prop="ptype"
                align="center"
              />
              <el-table-column
                align="center"
                label="设备状态"
              >
                <template #default="{row}">
                  <el-link v-if="row.isexpiresoon" :underline="false" type="danger">即将到期</el-link>
                  <el-link v-else :underline="false" type="primary">正常</el-link>
                </template>
              </el-table-column>
              <el-table-column
                label="设备到期时间"
                align="center"
              >
                <template #default="{row}">
                  <el-link v-if="row.expiretime" :underline="false" type="danger">
                    {{ row.expiretime | dateFilter('yyyy-MM-dd') }}
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-row>
      </el-card>
      <DeviceRechargeDialog
        :dialog-show.sync="showChargeDialog"
        :gateway-list="selectRows"
        @paysuccess="paysuccessCall"
        @orderexpire="orderExpireCall"
      />
    </div>
  </div>
</template>

<script>
import { QueryGatewaysByUser } from '@/api/Payment/actions'
import { Messsage } from 'element-ui'
import DeviceRechargeDialog from '@/components/Recharge/device/index.vue'
export default {
  name: 'DeviceRecharge',
  components: {
    DeviceRechargeDialog
  },
  data () {
    return {
      /**
       * 是否正在获取列表数据
       */
      loading: false,
      /**
       * 表格数据
       */
      tableData: [],
      /**
       * 勾选的表格行
       */
      selectRows: [],
      /**
       * 是否显示充值dialog
       */
      showChargeDialog: false,
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    /** 充值续费 */
    recharge () {
      const currentSelectRows = this.$refs['multipleTable'].selection || []
      if (currentSelectRows.length === 0) {
        this.$message({
          type: 'warning',
          message: '没有要充值的设备！',
          duration: 1 * 1000
        })
      } else {
        this.selectRows = JSON.parse(JSON.stringify(currentSelectRows))
        this.showChargeDialog = true
      }
    },
    /** 是否可勾选 */
    selectable (row) {
      return !!row.id
    },
    /** 获取表格数据 */
    getTableData () {
      this.loading = true
      QueryGatewaysByUser()
        .then(res => {
          this.loading = false
          this.tableData = res.data || []
          this.total = res.data.totalCount
        })
        .catch((error) => {
          this.loading = false
          Messsage.error(`获取采集器列表失败:${error}`)
        })
    },
    /** 支付成功回调 */
    paysuccessCall () {
      this.getTableData()
      this.showChargeDialog = false
      this.selectRows = []
    },
    /** 订单过期回调 */
    orderExpireCall () {
      this.showChargeDialog = false
      this.selectRows = []
    }
  }
}
</script>
<style lang='stylus' scoped>
.app-container{
  padding 10px
}
/deep/.el-form-item__label{
  text-align: center
}
.el-card
  background-color: #1D3666
  border: none
  >>>.el-table__empty-block
   background-color: #1D3666
 .el-table::before
   background-color: #1D3666
.el-table >>>.el-table__header thead th
  background:#053767
  color: #1CC197
.el-table >>>.el-table__body tr:nth-child(odd)
  background:#1A4A6E
  color: #fff
.el-table >>>.el-table__body tr:nth-child(even)
  background:#14466D
  color: #fff
.el-table >>>.el-table__body tr:hover>td
  background: rgba(28,193,151,.2)
.el-table >>>.el-table__body td,.el-table >>>.el-table__header th
    border: none
.el-table >>>.el-checkbox__inner
   border: thin solid #4fce6e
   border-radius: 2px
.el-table >>>.is-checked > span
   background-color: #4fce6e
   border-color: #4fce6e
</style>

